import { NullActionTypes } from 'generated/graphql-types';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export interface AutoAttendantKeyItemView {
   autoAttendantKeyId: number;
   extensionAutoAttendantId: number;
   routeToExtension: ExtensionOption | null;
   keyNumber: string | null;
   voiceMailOnly: boolean;
   routeToNullAction: NullActionTypes;
   isDeleted: boolean;
   selectedOption: string | null;
}

export const autoAttendantKeyFields: string[] = [
   'autoAttendantKeyId',
   'extensionAutoAttendantId',
   'keyNumber',
   'routeTo',
   'voiceMailOnly',
   'routeToNullAction',
];
